export default `varying vec3 vColor;

void main() {
    vec2 xy = gl_PointCoord.xy - vec2(0.5);
    float ll = length(xy);
    gl_FragColor = vec4(vColor, step(ll, 0.5));
}`